import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import CustomerList from "./components/CustomerList";
import ProtectedRoute from "./components/ProtectedRoute";
import CustomerViewPage from "./pages/CustomerViewPage";
import ArchivePage from "./pages/ArchivePage";
import Layout from "./components/Layout";
import { AuthProvider } from "./components/AuthContext";

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public route */}
          <Route path="/" element={<Login />} />

          {/* Protected routes wrapped by Layout and Auth */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <AppContent />
              </ProtectedRoute>
              
            }
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

const AppContent = () => {
  return (
    <Layout>
      <Routes>
        {/* Main Application Routes */}
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="customers" element={<CustomerList />} />
        <Route path="customers/view/:customerId" element={<CustomerViewPage />} /> 
        <Route path="archive" element={<ArchivePage />} />
    
        {/* Fallback/Home Page for Protected Routes */}
        <Route path="/" element={<Navigate to="dashboard" replace />} />
        <Route path="*" element={<Navigate to="dashboard" replace />} />
      </Routes>
    </Layout>
  );
}

export default App;
